export default "__VITE_ASSET__0c77134e__"